import cronstrue from 'cronstrue';
import moment from "moment-timezone";
import { AuditObjectTypes, UserModel } from "../_core/_model.ts";
import { LabelConstants } from "../Constants.ts";


export function AreObjectsEquals(a: any, b: any) {
    if (a === b) return true;

    if (typeof a !== "object" || typeof b !== "object" || a == null || b == null) {
        return false;
    }

    const keysA = Object.keys(a);
    const keysB = Object.keys(b);

    if (keysA.length !== keysB.length) return false;

    for (let key of keysA) {
        if (!keysB.includes(key) || !AreObjectsEquals(a[key], b[key])) {
            return false;
        }
    }
    return true;
}

export function GetObjectDifferences(a: any, b: any, parentKey = ''): string[] {
    const diffs: string[] = [];

    if (a === b) return diffs;

    if (typeof a !== "object" || typeof b !== "object" || a == null || b == null) {
        return [parentKey || ''];
    }

    const keys = new Set([...Object.keys(a), ...Object.keys(b)]);

    for (let key of keys) {
        const fullKey = parentKey ? `${parentKey}.${key}` : key;

        if (!(key in a) || !(key in b)) {
            diffs.push(fullKey);
        } else {
            const subDiffs = GetObjectDifferences(a[key], b[key], fullKey);
            diffs.push(...subDiffs);
        }
    }

    return diffs;
}

// FIX: Added 'string' type to the word parameter
export function singularize(word: string) {
    if (word.endsWith('ies')) {
        return word.slice(0, -3) + 'y'; // e.g. "parties" → "party"
    }
    if (word.endsWith('es')) {
        return word.slice(0, -2); // e.g. "boxes" → "box"
    }
    if (word.endsWith('s') && word.length > 1) {
        return word.slice(0, -1); // e.g. "cars" → "car"
    }
    return word;
}


export const getUserName = (usr: UserModel | undefined) => {
    if (typeof usr != 'undefined') {
        let name = (usr.userFirstName || "") + " " + (usr.userLastName || "");

        // FIX: Replaced .isEmpty() (which doesn't exist in JS) with .trim() checks
        if (!name.trim()) {
            name = usr.userName || "";
        }
        return name.trim();
    }
    return "";
}


export function getAuditObjectName(objType: AuditObjectTypes | undefined) {
    let name = "";
    switch (objType) {
        case AuditObjectTypes.ReportDistributions:
            name = "Report Distributions";
            break;
        case AuditObjectTypes.Role:
            name = "Roles";
            break;
        case AuditObjectTypes.RoleGroup:
            name = LabelConstants.RoleGroups;
            break;
        case AuditObjectTypes.Settings:
            name = "Configurations";
            break;
        case AuditObjectTypes.User:
            name = "Users";
            break;
        case AuditObjectTypes.UserRequest:
            name = "User Security Request";
            break;
        case AuditObjectTypes.ADConfig:
            name = "User Security Request";
            break;
        case AuditObjectTypes.Dimensions:
            name = "Dimension Configurations";
            break;
        case AuditObjectTypes.EmailConfig:
            name = "Email Configurations";
            break;
        case AuditObjectTypes.EmailTemplate:
            name = "Email Templates";
            break;
        case AuditObjectTypes.Flow:
            name = "User Creation Flow";
            break;
        case AuditObjectTypes.Report:
            name = "Reports";
            break;

    }
    return name;
}

export const getMyLocalTime = (tString: string | undefined | null) => {
    return moment.tz(tString, 'America/Los_Angeles').local().format("D MMM, YY h:mm A");
}

export const getMomentObj = (tString: string) => {
    return moment.tz(tString, 'America/Los_Angeles');
}

export const getFriendlyDate = (dateStr: string): string => {
    // Parse as if the time is in America/New_York (EST/EDT)
    const date = moment.tz(dateStr, 'America/Los_Angeles').local();
    const now = moment();

    if (now.isSame(date, "day")) {
        return `Today at ${date.format("h:mm A")}`;
    } else if (now.clone().subtract(1, "day").isSame(date, "day")) {
        return `Yesterday at ${date.format("h:mm A")}`;
    } else if (now.diff(date, "days") < 7) {
        return `${date.format("dddd [at] h:mm A")}`;
    } else if (now.isSame(date, "month")) {
        return `Earlier this month on ${date.format("D MMM")}`;
    } else {
        return date.format("DD MMM YYYY, h:mm A");
    }
};

export function getReadableCron(cronExpr: string): string {
    try {
        return cronstrue.toString(cronExpr, { use24HourTimeFormat: true, verbose: false });
    } catch (error) {
        return 'Invalid cron expression';
    }
}

export const getTextFromHtml = (htmlString: string): string => {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    return doc.body.textContent || '';
}